import {
  getIndStocksBackgroundUrl,
  getIndianStockCatalogUrl,
  getIndianStockBrokerUrl,
  getVyaparBackgroundOfficeUrls,
  getVyaparServiceUrl,
} from '../url-constants'

export const IND_STOCKS_CATELOGUE = '/catalog/v2/get-entity-details/'
export const IND_STOCKS_BASEPATH = getIndianStockBrokerUrl()
export const IND_STOCKS_BG_BASEPATH = getIndStocksBackgroundUrl()
export const IND_STOCKS_PORTFOLIO = '/portfolio/get-user-state?state=cold,warm'
export const IND_STOCKS_IDENTIFIER = 'INDStocks'
export const IND_STOCKS_INFOGRAPHICS = '/catalog/infographics/details'
export const IND_STOCKS_JWT_AUTH = `/auth/ws/jwt`
export const IN_STOCKS_EXPLORE = `${IND_STOCKS_BASEPATH}/catalog/v2/explore`
export const IN_STOCKS_BG_EXPLORE = `${IND_STOCKS_BG_BASEPATH}/catalog/v2/explore`
export const IN_STOCKS_INDICIES = `${IND_STOCKS_BASEPATH}/catalog/indices`
export const VYAPER_HOST = getVyaparBackgroundOfficeUrls()
export const IN_STOCKS_CLOSURE = `${VYAPER_HOST}/static/user/account/closure-details`
export const IN_STOCKS_CATALOG_LISTING = `${IND_STOCKS_BASEPATH}/catalog/listing`
export const IN_STOCKS_GET_CANDLES = `/catalog/candles/`
export const IN_INDEX_ETF = `${getIndianStockCatalogUrl()}/get-index-etfs`
export const VYAPER__HOST = getVyaparServiceUrl()
export const IN_PLEDGING_HOLDINGS = `${IND_STOCKS_BASEPATH}/portfolio/pledge-holdings?response_format=json`
export const IN_PLEDGING_SCREEN = `${VYAPER__HOST}/api/v1/pledge/pledge-screen?response_format=rest`
export const IN_PLEDGING_SUBMIT = `${VYAPER__HOST}/api/v1/pledge/submit`
export const IN_PLEDGING_ORDER_STATUS = `${VYAPER__HOST}/api/v1/pledge/order/status`
export const IN_PLEDGING_STATUS = `${VYAPER__HOST}/api/v1/pledge/status`
export const IN_UNPLEDGING_SCREEN = `${VYAPER__HOST}/api/v1/unpledge/unpledge-screen?response_format=rest`
export const IN_UNPLEDGING_SUBMIT = `${VYAPER__HOST}/api/v1/unpledge/submit`
export const IN_UNPLEDGING_STATUS = `${VYAPER__HOST}api/v1/unpledge/status`
export const IN_PROFILE_HOTLISTING = `${getVyaparBackgroundOfficeUrls()}/onboard/hotlisting/initiate`
export const IN_PROFILE_HOTLISTING_STATUS = `${getVyaparBackgroundOfficeUrls()}/onboard/hotlisting/status`
export const IN_STOCKS_ENTITY_INFO = `${IND_STOCKS_BASEPATH}/catalog/get-entity-info`
export const IN_STOCKS_TAX_PNL_SCREEN = `${getVyaparBackgroundOfficeUrls()}/static/tax-pnl-screen`
